import { useNavigate, useLocation } from 'react-router-dom';
import { useCallback, useEffect } from 'react';

/**
 * Universal "Contact Us" navigation.
 * - If on `/` → smooth-scroll to <section id="contact">
 * - Otherwise → navigate to `/#contact`; the HashScrollHandler mounted once in App.js
 *   will smooth-scroll after the home page mounts.
 */
export function useGoToContact() {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    if (location.pathname === '/') {
      const el = document.getElementById('contact');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    navigate('/#contact');
  }, [location.pathname, navigate]);
}

/**
 * Mount once inside App.js (inside <Router>). Watches for route + hash changes
 * and smoothly scrolls to the targeted element after the page renders.
 */
export function HashScrollHandler() {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace('#', '');
    // Wait a tick so the target page's DOM is mounted
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 120);
    return () => clearTimeout(t);
  }, [location]);
  return null;
}
